<template>
    <td style="text-align: center; font-size: 11px" :class="color()">
        <table style="background-color: #fff">
          <tr v-if="checkin != 'WW:WW'"><td style="text-align: center;">{{checkin == 'XX:XX' || checkin == '' || checkin == undefined || checkin == null ? '00:00' : checkin}}</td><td style="text-align: center;">{{checkout == 'XX:XX' || checkout == '' || checkout == undefined || checkout == null ? '00:00' : checkout}}</td></tr>
          <tr><td style="text-align: center;">{{total}}</td><td style="text-align: center;">{{done}}</td></tr>
          <tr><td colspan="2" style="text-align: center;">{{percentage}} %</td></tr>
        </table>
      </td>
</template>

<script>

import store from '../../store'

export default {
  name: 'DailyVisits',
  props: {
    checkin: String,
    checkout: String,
    total: Number,
    done: Number,
    percentage: String
  },
  data () {
    return {
    }
  },
  methods: {
    color(){
      let color = "default";

      if(this.checkin == 'XX:XX' || this.checkin == 'WW:WW'){
        return color;
      }

      if(this.percentage >= 90){
        color = "darkgreen";
      }
      else if(this.percentage >= 70){
        color = "green";
      }
      else if(this.percentage >= 50){
        color = "yellow";
      }
      else if(this.percentage >= 30){
        color = "red";
      }
      else if(this.percentage >= 0){
        color = "darkred";
      }

      return color;
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>

<style>
  .darkgreen{
    background-color: #2ecc71;
  }
  .green{
    background-color: #a9dfbf;
  }
  .yellow{
    background-color: #f9e79f;
  }
  .red{
    background-color: #f5b7b1;
  }
  .darkred{
    background-color: #e74c3c;
  }
  .default{
    background-color: #ffffff;
  }
</style>